$(function(){
	var ESlider = function(slider, images) {
		var _ = function(selector) {
			return document.querySelector(selector);
		}
	
		var __ = function(selector) {
			return document.querySelectorAll(selector);
		}
	
		this.slider = _(slider);
		
		this.images = images;
		this.slides = "";
		this.currentSlide;
		
		this.slider.classList.add("ESlider");
		
		this.slides = "";
		this.bulks = "<div class='ESlider-bulks-container'>";
		this.images.forEach(function(image, index) {
			
			var active_class = (index === 0) ? ' ESlider-active-slide ' : '';
			
			this.slides += "<img class='ESlider-slide ESlider-slide-" + (index + 1) + active_class + "' src='" + image + "' />";
			this.bulks += "<span class='ESlider-bulk' data-slide-id='"+ (index+1) + "'><img src='" + image + "' class='ESlider-thumbnail' /></span>";
		}.bind(this));
	
		this.bulks += "</div>";
		this.contronls = "<span class='ESlider-previous'></span><span class='ESlider-next'></span>";
		this.slider.innerHTML += this.slides + this.bulks + this.contronls;
	
		this.interval = function() {
			this.autoSlide = setInterval(function() {
				this.next();
			}.bind(this), 5000);
		}.bind(this);
	
		this.setSlide = function(id) {
			clearInterval(this.autoSlide);
			if(!_(slider + " .ESlider-active-slide"))
				return;
			
			if (_(slider + " .ESlider-active-slide") !== null)
				_(slider + " .ESlider-active-slide").classList.remove("ESlider-active-slide");
	
			if (_(slider + " .ESlider-active-bulk") !== null)
				_(slider + " .ESlider-active-bulk").classList.remove("ESlider-active-bulk");
	
			_(slider + " .ESlider-slide-" + id).classList.add("ESlider-active-slide");
			_(slider + " .ESlider-bulk[data-slide-id='" + id + "']").classList.add("ESlider-active-bulk");
			
			var curr_height_listener = setInterval(function(){
				if( $(slider + " .ESlider-slide-" + id).hasClass('ESlider-active-slide') )
					_(slider).style.height = _(slider + " .ESlider-slide-" + id).clientHeight + "px";
				else
					clearInterval(curr_height_listener);
			},200);
			this.currentSlide = id;
			
			this.interval();
		}
	
		this.next = function() {
			
			if (this.currentSlide == this.images.length)
				this.currentSlide = 1;
			else
				this.currentSlide++;
			this.setSlide(this.currentSlide);
		}
		
		this.previous = function() {
			if (this.currentSlide == 1)
				this.currentSlide = this.images.length;
			else
				this.currentSlide--;
			this.setSlide(this.currentSlide);
		}
		
		var bulks = __(slider + " .ESlider-bulk");
		for (var i = 0; i < bulks.length; i++) {
			bulks[i].addEventListener("click", function(e) {
				var slideID = e.target.dataset.slideId;
				this.setSlide(slideID);
			}.bind(this));
		}
		
		_(slider + " .ESlider-previous").addEventListener("click", function(e) {
			this.previous();
		}.bind(this));
		
		_(slider + " .ESlider-next").addEventListener("click", function(e) {
			this.next();
		}.bind(this));
		
		this.setSlide(1);
	};	
	
	var resources_prefix = WebSystem.get_resources_prefix('contents');
	var slider = new ESlider("#slider-1", [
		resources_prefix + "assets/web_contents/1.jpg",
		resources_prefix + "assets/web_contents/2.jpg",
		resources_prefix + "assets/web_contents/3.jpg",
		resources_prefix + "assets/web_contents/4.jpg",
		resources_prefix + "assets/web_contents/5.jpg",
		resources_prefix + "assets/web_contents/6.jpg",
		resources_prefix + "assets/web_contents/7.jpg"
	]);
	var slider = new ESlider("#slider-2", [
		resources_prefix + "assets/web_contents/1.jpg",
		resources_prefix + "assets/web_contents/2.jpg",
		resources_prefix + "assets/web_contents/3.jpg",
		resources_prefix + "assets/web_contents/4.jpg",
		resources_prefix + "assets/web_contents/5.jpg",
		resources_prefix + "assets/web_contents/6.jpg",
		resources_prefix + "assets/web_contents/7.jpg"
	]);
});

$(document).on('click', 'a[data-goto]', function(e){
	
	var dest = $(this).data('goto');
	console.log('Buscando zona destino: "'+dest+'"');
	if( $('#container').css('display') !== 'none' ){
		//Scroll "horizontal"
		if($('#container').find(dest).length !== 0){
			var dest_offset_left = $('#container').find(dest)[0].getBoundingClientRect().left;
			dest_offset_left = $('#container').scrollTop() + dest_offset_left;
			console.log('Destino en "X": ',$('#container').find(dest));
			$('#container').stop().animate({scrollTop: dest_offset_left}, '500', 'swing');			
		}
	}else{
		//Scroll vertical
		var dest_offset_top = $('#container-mobile').find(dest).offset().top;
		console.log('Destino en Y: ',$('#container-mobile').find(dest));
		$('html,body').stop().animate({scrollTop: dest_offset_top}, '500', 'swing');
	}
	e.preventDefault();
	return false;
});

$(function() {

	// variables
	elementWidth = $('ul').width(),
	containerWidth = $('nav').width(),
	difference = elementWidth-containerWidth,
	finalWidth = difference * 1.5,
	element = $('ul');
	// active on click
	$('li').on('click', function(){
		$('li').removeClass('active');
		$(this).addClass('active');
	});
	

	$(window).scroll(function(e){
	  parallaxScroll();
	});
	 
	 
	function parallaxScroll(){
		var scrolled = $(window).scrollTop();
		$('#artefacto').css('top',(0-(scrolled*1.25))+'px');
		$('#cabeza').css('top',(0-(scrolled*.4))+'px');
		$('#cuadro').css('top',(0-(scrolled*.75))+'px');
	}


	function fade($ele) {
		$ele.fadeIn(1000).delay(7000).fadeOut(1000, function() {
			var $next = $(this).next('.quote');
			fade($next.length > 0 ? $next : $(this).parent().children().first());
		});
	}
	fade($('.quoteLoop > .quote').first());


	function fade($ele) {
		$ele.fadeIn(1000).delay(5000).fadeOut(1000, function() {
			var $next = $(this).next('.mquote');
			fade($next.length > 0 ? $next : $(this).parent().children().first());
		});
	}
	fade($('.mquoteLoop > .mquote').first());


	var audio1 = document.getElementById("audioID");
	$('#cat_audio').click(function(){
		audio1.play();
	});
	/*function playAudio() {
	  audio1.play();
	}*/

});